<div class="qb-d-flex qb-fd-coloumn qb-h-100">
  <div class="qb-get-data-container">
    <div class="qb-get-data-wrapper qb-h-100">
      <form [formGroup]="dataForm" style="padding: 13px">
        <div>
          <span class="main-label-style">
            {{ "SHARED_PAGE.MILESTONE_NAME" | i18nTranslate }}
          </span>
          <span style="color: #c71a1a; font-size: 12px">*</span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <ngx-editor
                [editor]="nameEditor"
                formControlName="name"
                (keydown)="stringInputHandler($event, 50, 'name')"
                [ngClass]="{
                  error:
                    dataForm.get('name')?.errors &&
                    (dataForm.get('name')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="nameEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{ getCountOfText(dataForm.get("name")?.value) || 0 }}/50
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="name-error"
            >
              <span
                *ngIf="duplicateNameErrorText"
                style="color: var(--main-font-red); font-size: 12px"
                >{{ duplicateNameErrorText }}</span
              >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style">
            Alias {{ "SHARED_PAGE.MILESTONE_NAME" | i18nTranslate }}
          </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <!-- NgxEditor Component -->
              <ngx-editor
                [editor]="aliasNameEditor"
                formControlName="aliasName"
                (keydown)="stringInputHandler($event, 50, 'aliasName')"
                [ngClass]="{
                  error:
                    dataForm.get('aliasName')?.errors &&
                    (dataForm.get('aliasName')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="aliasNameEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{ getCountOfText(dataForm.get("aliasName")?.value) || 0 }}/50
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="aliasName-error"
            >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style"> Milestone Heading </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel challenge-heading">
              <!-- NgxEditor Component -->
              <ngx-editor
                class="custom-editor"
                [editor]="headerEditor"
                formControlName="header"
                (keydown)="stringInputHandler($event, 50, 'header')"
                [ngClass]="{
                  error:
                    dataForm.get('header')?.errors &&
                    (dataForm.get('header')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="headerEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{ getCountOfText(dataForm.get("header")?.value) || 0 }}/50
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="header-error"
            >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style">
            {{ "SHARED_PAGE.MILESTONE_DESCRIPTION" | i18nTranslate }}
          </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <!-- NgxEditor Component -->
              <ngx-editor
                [editor]="descriptionEditor"
                formControlName="description"
                (keydown)="stringInputHandler($event, 300, 'description')"
                [ngClass]="{
                  error:
                    dataForm.get('description')?.errors &&
                    (dataForm.get('description')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="descriptionEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{
                  getCountOfText(dataForm.get("description")?.value) || 0
                }}/300
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="description-error"
            >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style">
            Alias {{ "SHARED_PAGE.MILESTONE_DESCRIPTION" | i18nTranslate }}
          </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <!-- NgxEditor Component -->
              <ngx-editor
                [editor]="aliasDescriptionEditor"
                formControlName="aliasDescription"
                (keydown)="stringInputHandler($event, 300, 'aliasDescription')"
                [ngClass]="{
                  error:
                    dataForm.get('aliasDescription')?.errors &&
                    (dataForm.get('aliasDescription')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu
                [editor]="aliasDescriptionEditor"
                [toolbar]="toolbar"
              >
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{
                  getCountOfText(dataForm.get("aliasDescription")?.value) || 0
                }}/300
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="aliasDescription-error"
            >
            </span>
          </div>
        </div>

      </form>
      <div class="each-upload" style="padding: 0px 13px;">
        <div class="d-flex align-items-center">
          <label class="main-label-style">Upload Milestone Icon</label>
          <span class="material-symbols-outlined remove-img" *ngIf="badgeImageUrl" [matTooltip]="'Remove image'" (click)="badgeImageUrl = null">cancel</span>
        </div>
        <div
          class="upload-coin-img"
          (click)="fileInput.click()"
          *ngIf="!badgeImageUrl && !uploading1"
        >
          <div class="margin-0">Click here to upload your image [.png .jpg]</div>
          <span class="material-symbols-outlined"> cloud_upload </span>
        </div>
        <app-qubriux-loading
          [size]="35"
          *ngIf="uploading1"
        ></app-qubriux-loading>
        <div *ngIf="badgeImageUrl && !uploading1" class="img-plus-upload">
          <img class="uploaded-image" [src]="badgeImageUrl" />
          <div class="upload-coin-img" (click)="fileInput.click()">
            <div class="margin-0">Click here to replace your image [.png .jpg] </div>
            <span class="material-symbols-outlined"> cloud_upload </span>
          </div>
        </div>
        <input
          type="file"
          accept=".png, .jpg"
          #fileInput
          (change)="setUploadedFile($event, 'MILESTONE')"
          hidden="true"
        />
      </div>
      <div [ngClass]="{'cursor-notallowed':status=='ACTIVE' }"  >
        <div [ngClass]="{'pointerevents-none':status=='ACTIVE' }"      >
          <app-challenges-milestone-config-set-up
            #milestoneConfig
            [isEdit]="isEdit"
          ></app-challenges-milestone-config-set-up>
        </div>
      </div>
      
    </div>
    <div class="qb-button-container-challenge-selection">
      <div class="secondary-button qb-secondary-button-save-exit" (click)="selectChallengeType('goback')" *ngIf="!isEdit">
        Go Back
      </div>
      <div class="secondary-button" (click)="selectChallengeType('exit')">
        Save and Exit
      </div>
      <div class="primary-button" (click)="selectChallengeType('reward')">
        Next
      </div>
    </div>
  </div>
</div>
